<template>
    <div id="favorite-shop-page">
        <div class="page-heading">
            <h2 class="display-4 montserrat-bold mb-0">Favorite Shops</h2>
            <div class="mt--2 heading-small">Preferred Shops For Your Bookings</div>
        </div>

        <div class="bg-white shadow-reg list-container card-list-container">
            <paginated-section class="card-list" :fetch-link="shopFetchLink" paginate-path="data.result.shops" ref="list" simplified>
                <template slot="loading">
                    <h3 class="table-placeholder text-muted m-0 pt-5 pb-5 text-center">
                        <i class="fas fa-spin fa-spinner mr-2"></i> Loading shops
                    </h3>
                </template>
                <template slot="empty">
                    <h3 class="table-placeholder text-muted m-0 pt-5 pb-5 text-center">No shops were found</h3>
                </template>
                <template slot="body" slot-scope="{ record }">
                    <favorite-shop-list-item :shop="record" @deleted="shopRemoved" />
                </template>
            </paginated-section>
        </div>

    </div>
</template> 
<script>
import '@styles/table.css';
import FavoriteShopListItem from "./FavoriteShopListItem";
import { route, get } from "@utils/network";

export default {
    name: "FavoriteShopListPage",

    components: { FavoriteShopListItem },

    data: () => ({
        shopFetchLink: route("customers/favorite-shops"),
    }),

    methods: {
        shopRemoved() {
            this.$refs.list.refresh();
        }
    },

    mounted() {
        this.$emit("mounted");
    }
}
</script>